var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartPeach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05751 11.7479L9.86825 19.4222C10.1924 19.7406 10.6204 19.918 11.0656 19.918C11.5108 19.918 11.9387 19.7406 12.2629 19.4222L20.0736 11.7479C21.3877 10.4605 22.1311 8.65455 22.1311 6.76669V6.50285C22.1311 3.32305 19.9483 0.611808 16.9701 0.088666C14.999 -0.257063 12.9934 0.420748 11.5843 1.90374L11.0656 2.44963L10.5469 1.90374C9.13774 0.420748 7.13211 -0.257063 5.16105 0.088666C2.18286 0.611808 0 3.32305 0 6.50285V6.76669C0 8.65455 0.743468 10.4605 2.05751 11.7479Z",
    fill: "#FBC2B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPeach);
export default __webpack_public_path__ + "static/media/heart-peach.623305a72ee1e45ae0825004f46ce78e.svg";
export { ForwardRef as ReactComponent };